import {
  FETCH_START,
  FETCH_SUCCESS,
  FETCH_ERROR,
  SHOW_MESSAGE,
  GET_DROPZZ,
  GET_DROPZZ_ITEM,
  SET_DROPZZ_PAGE,
  SET_DROPZZ_LIST_TYPE,
} from '../../shared/constants/ActionTypes';
import jwtAxios from '@crema/services/auth/jwt-auth/jwt-api';
import {
  getDropzzErrorMessage,
  normalizeDropzzItem,
  normalizeDropzzList,
} from 'pages/admin/Dropzz/dropzzUtils';

const GENERIC_ERROR_KEY_FALLBACK =
  'Something went wrong, Please try again!';

const isHttpOk = (status) => status === 200 || status === 201 || status === 204;

const handleApiFailure = (dispatch, payload, fallbackMessage) => {
  if (payload?.succeeded === false) {
    const errors = Array.isArray(payload?.errors)
      ? payload.errors.filter(Boolean).join(' ')
      : '';
    dispatch({
      type: FETCH_ERROR,
      payload: errors || payload?.message || fallbackMessage,
    });
    return true;
  }
  return false;
};

const getListPath = (listType) => {
  if (listType === 'live') {
    return '/dropzz/live';
  }
  if (listType === 'upcoming') {
    return '/dropzz/upcoming';
  }
  return '/dropzz';
};

export const setDropzzPage = (page) => ({
  type: SET_DROPZZ_PAGE,
  payload: page,
});

export const setDropzzListType = (listType) => ({
  type: SET_DROPZZ_LIST_TYPE,
  payload: listType,
});

export const getDropzzList = (limit = 10) => {
  return (dispatch, getState) => {
    const {page, listType} = getState().dropzz;
    dispatch({type: FETCH_START});
    jwtAxios
      .get(getListPath(listType), {
        params: {
          pageNo: page,
          pageSize: limit,
        },
      })
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data, GENERIC_ERROR_KEY_FALLBACK)) {
            return;
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: GET_DROPZZ,
            payload: normalizeDropzzList(res.data),
          });
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: GENERIC_ERROR_KEY_FALLBACK,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR_KEY_FALLBACK),
        });
      });
  };
};

export const getDropzzById = (auctionId) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    return jwtAxios
      .get(`/dropzz/${auctionId}`)
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data, GENERIC_ERROR_KEY_FALLBACK)) {
            return null;
          }
          const item = normalizeDropzzItem(res.data);
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: GET_DROPZZ_ITEM,
            payload: item,
          });
          return item;
        }
        dispatch({
          type: FETCH_ERROR,
          payload: GENERIC_ERROR_KEY_FALLBACK,
        });
        return null;
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR_KEY_FALLBACK),
        });
        return null;
      });
  };
};

export const addDropzz = (body) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .post('/dropzz', body)
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data, GENERIC_ERROR_KEY_FALLBACK)) {
            return;
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: res?.data?.message,
          });
          dispatch(getDropzzList());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: GENERIC_ERROR_KEY_FALLBACK,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR_KEY_FALLBACK),
        });
      });
  };
};

export const updateDropzz = (auctionId, body) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .put(`/dropzz/${auctionId}`, body)
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data, GENERIC_ERROR_KEY_FALLBACK)) {
            return;
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: res?.data?.message,
          });
          dispatch(getDropzzList());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: GENERIC_ERROR_KEY_FALLBACK,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR_KEY_FALLBACK),
        });
      });
  };
};

export const publishDropzz = (auctionId) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .post(`/dropzz/${auctionId}/publish`)
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data, GENERIC_ERROR_KEY_FALLBACK)) {
            return;
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: res?.data?.message,
          });
          dispatch(getDropzzList());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: GENERIC_ERROR_KEY_FALLBACK,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR_KEY_FALLBACK),
        });
      });
  };
};

export const unpublishDropzz = (auctionId) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .post(`/dropzz/${auctionId}/unpublish`)
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data, GENERIC_ERROR_KEY_FALLBACK)) {
            return;
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: res?.data?.message,
          });
          dispatch(getDropzzList());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: GENERIC_ERROR_KEY_FALLBACK,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR_KEY_FALLBACK),
        });
      });
  };
};

export const notifyDropzzWinner = (auctionId) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .post(`/dropzz/${auctionId}/notify-winner`)
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data, GENERIC_ERROR_KEY_FALLBACK)) {
            return;
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: res?.data?.message,
          });
          dispatch(getDropzzList());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: GENERIC_ERROR_KEY_FALLBACK,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR_KEY_FALLBACK),
        });
      });
  };
};

export const cancelDropzz = (auctionId) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .post(`/dropzz/${auctionId}/cancel`)
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data, GENERIC_ERROR_KEY_FALLBACK)) {
            return;
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: res?.data?.message,
          });
          dispatch(getDropzzList());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: GENERIC_ERROR_KEY_FALLBACK,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR_KEY_FALLBACK),
        });
      });
  };
};

export const updateDropzzOutcome = (auctionId, body) => {
  return (dispatch) => {
    dispatch({type: FETCH_START});
    jwtAxios
      .put(`/dropzz/${auctionId}/outcome`, body)
      .then((res) => {
        if (isHttpOk(res.status)) {
          if (handleApiFailure(dispatch, res.data, GENERIC_ERROR_KEY_FALLBACK)) {
            return;
          }
          dispatch({type: FETCH_SUCCESS});
          dispatch({
            type: SHOW_MESSAGE,
            payload: res?.data?.message,
          });
          dispatch(getDropzzList());
        } else {
          dispatch({
            type: FETCH_ERROR,
            payload: GENERIC_ERROR_KEY_FALLBACK,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: FETCH_ERROR,
          payload: getDropzzErrorMessage(error, GENERIC_ERROR_KEY_FALLBACK),
        });
      });
  };
};
